import React, {
  RefObject,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';

import FilterChips, {
  FilterChipValue
} from '../../../../library/filter-chips/filter-chips';
import FilterButton from '../filter-button/filter-button';

import { isChipFilter } from '../../../../shared/utils/filters/filters';

import './sticky-filter-chips.scss';

interface StickyFilterChipsProps {
  clearSelectedFilters: () => void;
  onChipClick: (filterChip: FilterChipValue) => void;
  onToggleMobileFilter: () => void;
  resultsBarRef: RefObject<HTMLDivElement>;
  selectedFilters: FilterChipValue[];
}

function StickyFilterChips(props: StickyFilterChipsProps) {
  const {
    clearSelectedFilters,
    onChipClick,
    onToggleMobileFilter,
    resultsBarRef,
    selectedFilters
  } = props;

  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [isTransformActive, setIsTransformActive] = useState(false);
  let lastScrollTopRef = useRef(0);

  const handleScroll = useCallback(() => {
    const currentScrollTop = window.scrollY;

    if (resultsBarRef?.current) {
      const initialOffSetY =
        resultsBarRef.current.getBoundingClientRect().top + currentScrollTop;

      if (currentScrollTop < initialOffSetY) {
        setShowMobileFilters(false);
        setIsTransformActive(false);
      } else {
        if (
          (currentScrollTop >= initialOffSetY &&
            currentScrollTop <= initialOffSetY + 250) ||
          (currentScrollTop >= initialOffSetY + 250 &&
            currentScrollTop < lastScrollTopRef.current)
        ) {
          setIsTransformActive(false);
          setShowMobileFilters(true);
        } else {
          setIsTransformActive(true);
        }
      }

      lastScrollTopRef.current = currentScrollTop <= 0 ? 0 : currentScrollTop;
    }
  }, [resultsBarRef, setShowMobileFilters]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <div
      styleName={`container ${showMobileFilters ? 'sticky-active' : ''} ${
        isTransformActive ? 'transform-active' : ''
      } `}
    >
      {showMobileFilters && (
        <FilterButton
          filterCount={selectedFilters?.length}
          onToggleMobileFilter={onToggleMobileFilter}
          styleName="filter-button"
        />
      )}

      <FilterChips
        filters={selectedFilters?.filter(isChipFilter)}
        onChipClick={onChipClick}
        onClearAllClick={clearSelectedFilters}
        showClearAll
        styleName="filter-chips"
      />
    </div>
  );
}

export default StickyFilterChips;
